import { useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { log } from '../lib/logger';
import type { CrewPortalResult } from '../types/crewPortal';

export function useCrewPortal() {
  const createPortal = useCallback(async (userId: string): Promise<CrewPortalResult | null> => {
    const { data, error } = await supabase.rpc('create_crew_portal', { p_user_id: userId });
    if (error) {
      log.error('Create portal error:', error.message);
      return null;
    }
    return data as CrewPortalResult;
  }, []);

  const revokePortal = useCallback(async (userId: string): Promise<boolean> => {
    const { error } = await supabase.rpc('revoke_crew_portal', { p_user_id: userId });
    if (error) {
      log.error('Revoke portal error:', error.message);
      return false;
    }
    return true;
  }, []);

  const reactivatePortal = useCallback(async (userId: string): Promise<CrewPortalResult | null> => {
    const { data, error } = await supabase.rpc('reactivate_crew_portal', { p_user_id: userId });
    if (error) {
      log.error('Reactivate portal error:', error.message);
      return null;
    }
    return data as CrewPortalResult;
  }, []);

  return { createPortal, revokePortal, reactivatePortal };
}
